<template>
  <div class="col-12 p-0 m-0" id="VestingInfo">
    <Breadcrumb :title="'Vesting Report'"></Breadcrumb>
    <VestingForm
      :ref="'VestingInfoForm'"
      :ProgramUnitClassJsonData="ProgramUnitClassJsonData"
      :VestingInfo="VestingJSON"
      :VestingModalLabel="modalConfig"
      :IsCorrection="true"
    ></VestingForm>
    <div class="form-row">
      <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
      <div class="form-group col-md-7">
        <!-- <label for="kendo-select" style="float:right;" >Vesting Filter</label> -->
        <div class="form-group" style="float:right; width:50%" id="kendo-select">
          <kendo-dropdownlist
            id="ddlVestingFilter"
            v-model="VestingFilterValue"
            :data-source="VestingTypeOptions"
            :data-text-field="'Option'"
            @change="onVestingFilterChange"
            :data-value-field="'Option'"
          ></kendo-dropdownlist>
        </div>
      </div>
    </div>
    <div class="btnDiv">
      <BaseToolBar
        @toggleButtonClicked="toggleFilterData"
        @buttonClicked="toolbarOnClick"
        :config="VestingReportToolBar"
      ></BaseToolBar>
    </div>
    <div>
      <BaseGrid
        :mode="'editform'"
        :excelExport="excelExport"
        :config="config"
        :data="VestingReportData"
        :colorizeColumn="true"
        @CorrectItem="CorrectVesting"
        @AttachItem="VestingAttachment"
      ></BaseGrid>
    </div>
    <VestingDocumentDropoffForm
      ref="vestingDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedVesting"
    ></VestingDocumentDropoffForm>
  </div>
</template>

<script>
import $ from "jquery";
import apiUtil from "@/services/apiUtil.js";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import BaseModelDocument from "@/models/BaseModelDocument.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelIssuance from "@/models/BaseModelIssuance.js";
import BaseModelTransfer from "@/models/BaseModelTransfer.js";
import toolbarUtility from "@/services/toolbarUtility.js";
import VestingMixin from "@/mixins/VestingMixin.js";
import moment from "moment";

import VestingReportConfig from "./VestingReportConfig.js";
import { VestingReportToolBar } from "./VestingReportConfig.js";

import VestingDocumentDropoffForm from "@/components/forms/VestingDocumentDropoffForm.vue";
import VestingForm from "@/components/forms/VestingForm.vue";

import { mapGetters, mapActions, mapState } from "vuex";
import _ from "lodash";
import { isNullOrUndefined } from "util";
import deepGroupBy from "@/services/groupByUtil.js";

export default {
  name: "VestingReport",
  mixins: [apiUtil, funcUtil, toolbarUtility, VestingMixin],
  computed: {
    ...mapGetters("getModule", ["withFilter"])
  },
  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolBar,
    VestingDocumentDropoffForm,
    VestingForm
  },
  data: function() {
    return {
      vestingreportGridId: "vestingReportGrid",
      VestingMasterData: {},
      config: VestingReportConfig,
      VestingReportToolBar: VestingReportToolBar,
      search: {
        SearchData: ""
      },
      // Document dropoff modal
      docModalConfig: {
        modalName: "Vesting Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
      // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      selectedVesting: {},
      ProgramUnitClassJsonData: { option: [] },
      modalConfig: { modalName: "", modalAddorEdit: "" },
      BaseModelUnitClass: BaseModelUnitClass,
      VestingJSON: {},
      VestingTypeOptions: [
        { Option: "All" },
        { Option: "Standard Vesting" },
        { Option: "Cliff Vesting" },
        { Option: "Special Vesting" }
      ],
      VestingFilterValue: "All",
      VestingReportData: [],
      selectedDate : null
    };
  },
  mounted() {
    //for DatePicker in Kendo ToolBar

    let self = this;
    var grid = $("#vestingReportGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateVestingMasterData);

    $("#dateAsOfDate").kendoDatePicker({
      change(e) {
        if (this.value()) {
          self.getVestingData(moment(this.value()));
        } else {
          self.getVestingData(new Date());
        }
        //var value = this.value();
        //self._filterDatabyDate(grid, null, value,"VestedDate");
      }
    });

    $("#standard").change(function() {
      if ($(this).is(":checked")) {
        console.log($("#standard").val());
      }
    });
    self.getVestingData(new Date());

    self._loadGridSettings(self.vestingreportGridId);
  },
  methods: {
    filterGrid() {
      let self = this;
      let currentMasterdata = this.VestingMasterData;
      let filteredData = this._filterGrid(
        this.VestingMasterData,
        this.search.SearchData
      );
      $("#vestingReportGrid")
        .data("kendoGrid")
        .dataSource.data(filteredData);
      this.UpdateVestingMasterData(true, currentMasterdata);
    },
    UpdateVestingMasterData: function(fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.VestingMasterData = filterMasterData;
      } else {
        this.VestingMasterData = $("#vestingReportGrid")
          .data()
          .kendoGrid.dataSource.data();
      }
    },
    toolbarOnClick: function(e) {
      //e.preventDefault();
      switch (e.id) {
        case "btnBulkAttachment":
          this.AttachBatchDocuments();
          break;

        default:
          break;
      }

      //var asOfDate=kendo.toString(this.SelectedDate, "MM/dd/yyyy");
      // let asOfDate = this.selectedDate;
      // //console.log("As of ",asOfDate,this.selectedDate,this.SelectedDate,this.PartnerInfoFormConfig);
      // //this.saveFileName=PartnerName+"_"
      // +HireDate+"_"+asOfDate+"_"+kendo.toString(new Date, "MM/dd/yyyy") + ".xlsx";
      var headerList=[
        {id:"As Of", value:moment(this.selectedDate).format("MM/DD/YYYY")},
        {id:"Report Generated On", value: moment(new Date()).format("MM/DD/YYYY")}
      ]
      var arguementList={
        ...arguments,
        fileName:"Vesting Report_"+moment(this.selectedDate).format("MM/DD/YYYY")+".xlsx",
        headers:headerList
      }
      this._baseToolBarEvents("vestingReportGrid", arguementList);
    },
    toggleFilterData: function(e) {
      e.preventDefault();
      this._baseToolBarEvents("vestingReportGrid", ...arguments);
    },
    CorrectVesting: function(e) {
      e.preventDefault();
      this.modalConfig.modalName = "Correct Vesting";
      this.modalConfig.modalAddorEdit = "edit";

      let gview = window.$("#vestingReportGrid").data("kendoGrid");
      let dataItem = JSON.parse(
        JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr")))
      );
      if (dataItem.WorkflowStatus == "Correction Pending") {
        this._AlertPopup(
          "Correction Pending.Any further changes can be made in correction page.",
          "info"
        );
      } else {
        this.VestingEditJSON = dataItem;
        this.VestingEditJSON.Percentage = Number(dataItem.Percentage);

        this.ProgramUnitClassJsonData.option = [];
        this.ProgramUnitClassJsonData.option = this.withFilter(
          BaseModelUnitClass.list,
          {
            filter: "ProgramId eq " + dataItem.ProgramId
          }
        );
        this.VestingJSON = this.VestingEditJSON;
        this.$refs.VestingInfoForm.calculateUnits(this.VestingJSON);
        window.$("#BaseModal").modal("toggle");
      }
    },
    // Vesting Documnet Dropoff
    VestingAttachment: function(e) {
      let self = this;
      e.preventDefault();
      const gview = window.$("#vestingReportGrid").data("kendoGrid");
      const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      this.selectedVesting = { ...dataItem };
      //TEMP: Only for Transfer Page.. Building Partner Record for the Time Being
      (this.selectedVesting.PartnerTitle = dataItem.ReceiverFullName),
        (this.selectedVesting.PartnerId = dataItem.ReceiverId);
      this.selectedVesting.TransactionID = dataItem.Id;

      this.filterCondition.batchQuery = true;

      let BatchGUIDArray = self.GetBatchGUIDArray(
        this.selectedVesting.BatchGUID
      );

      this.filterCondition.filter = function(o) {
        return (
          o.BusinessEvent == "Vesting" &&
          (o.TransactionID == dataItem.Id ||
            BatchGUIDArray.includes(o.BatchGUID))
        );
      };

      this.$refs.vestingDocument.$refs.vestingDocumentMgr.resetDropZoneGrid();
      window.$("#docModal").modal("toggle");
    },
    AttachBatchDocuments() {
      let selectedItem = [];
      let selectedRowCount = 0;

      //Get Next Batch Id
      const result = this.withFilter(BaseModelDocument.list, "");
      let batchId =
        result.length <= 0 ? 1 : this._getIncrementalID(result, "BatchGUID");

      //Partner Program Concatenated List Change
      let programIdlist = new Set();
      let partnerIdList = new Set();

      let grid = $("#vestingReportGrid").data("kendoGrid");
      grid.select().each(function() {
        selectedRowCount++;
        let selectedDataItem = JSON.parse(JSON.stringify(grid.dataItem(this)));
        let tempBatchId = [];
        if (
          !isNullOrUndefined(selectedDataItem.BatchGUID) &&
          !selectedDataItem.BatchGUID == ""
        ) {
          tempBatchId = selectedDataItem.BatchGUID.split(",");
        }
        tempBatchId.push(batchId);
        selectedDataItem.BatchGUID = tempBatchId.toString();

        selectedItem.push(selectedDataItem);
        programIdlist.add(selectedDataItem.ProgramId);
        partnerIdList.add(selectedDataItem.ReceiverId);
      });

      if (selectedRowCount <= 1) {
        this._AlertPopup("Please Select Atleast 2 Rows", "info");
      } else {
        const batchConfig = {
          Vesting: {
            config: VestingReportConfig,
            updateData: selectedItem
          }
        };

        this.selectedVesting = {};
        this.selectedVesting.ProgramId = null;
        this.selectedVesting.PartnerId = null;
        this.selectedVesting.ProgramIdList = [...programIdlist].toString();
        this.selectedVesting.PartnerIdList = [...partnerIdList].toString();
        this.selectedVesting.TransactionID = null;
        this.selectedVesting.BusinessEvent = "Vesting";
        this.selectedVesting.Type = "batch";
        this.selectedVesting.BatchGUID = batchId;
        this.selectedVesting.batchConfig = batchConfig;
        this.selectedVesting.parentGridId = "vestingReportGrid";

        this.filterCondition.batchQuery = false;

        this.filterCondition.filter = `BusinessEvent eq 'Vesting' and BatchGUID eq ${batchId}`;

        this.$refs.vestingDocument.$refs.vestingDocumentMgr.resetDropZoneGrid();

        window.$("#docModal").modal("toggle");
      }
    },
    onVestingFilterChange() {
      this.VestingFilterValue = $("#ddlVestingFilter")
        .data("kendoDropDownList")
        .text();
      let grid = $("#vestingReportGrid").data("kendoGrid");
      switch (this.VestingFilterValue) {
        case "All":
          this.filterGridRowByColumn(grid, "VestingType", "All", "neq");
          break;
        case "Standard Vesting":
          this.filterGridRowByColumn(grid, "VestingType", "Standard", "eq");
          break;
        case "Cliff Vesting":
          this.filterGridRowByColumn(grid, "VestingType", "Cliff", "eq");
          break;
        case "Special Vesting":
          this.filterGridRowByColumn(grid, "SpecialArrangement", "", "neq");
          break;
        default:
          break;
      }
    },
    getVestingData(inputDate) {
      const self = this;
      self.selectedDate = inputDate;
      this.VestingReportData = [];
      let VestingQuery = {
        batchQuery: true,
        filter: function(o) {
          return (
            o.BusinessEvent == "Vesting" &&
            (o.WorkflowStatus == "Approved" ||
              o.WorkflowStatus == "Correction Pending" ||
              o.WorkflowStatus == "Correction Approved") &&
              moment(o.VestedDate) < moment(inputDate)
            //o.SpecialArrangement != "Overridden" &&
            
          );
        }
      };
      let VestingReportDataTemp = this.withFilter(
        VestingReportConfig.list,
        VestingQuery
      );
      //Issunace Data
      let IssuanceQuery = {
        batchQuery: true,
        filter: function(o) {
          return (
            (o.WorkflowStatus == "Approved" &&
            o.ReceiverId!=1)
            && (o.VestingType == "Standard"
            || (o.VestingType=='Cliff' && !isNullOrUndefined(o.VestCliffDate)))
          );
        }
      };
      self._getVestingFromTransactions(
        BaseModelIssuance,
        IssuanceQuery,
        VestingReportDataTemp,
        inputDate
      );
      //Transfer datal
      let TransferQuery = {
        batchQuery: true,
        filter: function(o) {
          return (
            o.WorkflowStatus == "Approved" &&
            o.VestingType != "Custom"
          );
        }
      };
      self._getVestingFromTransactions(
        BaseModelTransfer,
        TransferQuery,
        VestingReportDataTemp,
        inputDate
      );

      //Aggregate VestingReportData-- Taking in Account Transfers
      self.AggregateVestingData(VestingReportDataTemp,inputDate);
      //console.log(VestingReportDataTemp)
      //self.VestingReportData = VestingReportDataTemp;
    },
    AggregateVestingData(VestingData,inputDate) {
      const self=this;
      let TempVesting = [];
      const getConfig1 = item => item.ProgramId;
      const getConfig2 = item => item.ReceiverId;
      const getConfig3 = item => item.UnitClass;
      const getConfig4 = item => item.UnitType;
      const getConfig5 = item => item.VestingType;
      const getConfig6 = item => item.UnitPool;

      var groupByResult = deepGroupBy(
        VestingData,
        getConfig1,
        getConfig2,
        getConfig3,
        getConfig4,
        getConfig5,
        getConfig6
      );
      console.log("grouped data");
      console.log(groupByResult)
      console.log("VestingData");
      console.log(VestingData);

      Object.keys(groupByResult).forEach(function(programKey, programIndex) {
        let programResult = groupByResult[programKey];
        Object.keys(programResult).forEach(function(partnerKey, partnerIndex) {
          let partnerResult = programResult[partnerKey];
          Object.keys(partnerResult).forEach(function(unitClassKey,unitClassIndex) {
            let unitClassResult = partnerResult[unitClassKey];
            Object.keys(unitClassResult).forEach(function(unitTypeKey,unitTypeIndex) {
              let unitTypeResult = unitClassResult[unitTypeKey];
              Object.keys(unitTypeResult).forEach(function(vestTypeKey,vestTypeIndex) {
                let vestTypeResult = unitTypeResult[vestTypeKey];
                Object.keys(vestTypeResult).forEach(function(unitPoolKey,unitPoolIndex) {
                let unitPoolResult = vestTypeResult[unitPoolKey];
                  let row = _.clone(unitPoolResult[0]);
                  row.Unit=self.calcSum(unitPoolResult,"Unit");
                  row.VestedUnit=self.calcSum(unitPoolResult,"VestedUnit");
                  //row.Percentage=unitPoolResult[0].Percentage;
                  row.Percentage= row.VestedUnit.toFixed(2)/row.Unit.toFixed(2);
                  row.Percentage = row.Percentage ? row.Percentage : 'N/A';
                  if(Number.isNaN(row.Percentage)) {
                    //console.log("row.Percentage",row,"\n",unitPoolResult[0].Percentage);
                    //console.log(row.VestedUnit,row.Unit);
                    row.Percentage=unitPoolResult[0].Percentage;
                  } 
                  row.VestedDate = (moment(row.VestedDate).unix() < 0 ? "" : row.VestedDate);
                  // if(row.ReceiverId == 1537) 
                  // {
                  //   console.log("victor",JSON.stringify(row));
                  // }
                  // else {
                  //   row.Percentage=row.VestedUnit/row.Unit;
                  //   row.Percentage = row.Percentage ? row.Percentage : 0;
                  // }
                  //row.Percentage=unitPoolResult[0].Percentage;
                  if((row.Percentage) > 1) {
                    console.log("row.Percentage",row,"\n",unitPoolResult[0].Percentage);
                    console.log(row.VestedUnit,row.Unit);
                  }
                  TempVesting.push(row)
              })
                
              });
            });
          });
        });
      });
      

      //Double Vesting % 
      VestingData.forEach(transaction => {
        if (transaction.SenderId) {
          //console.log("transaction",JSON.stringify(transaction));
          let index=TempVesting.findIndex(function(ele) {
            return ele.ProgramId==transaction.ProgramId && ele.ReceiverId==transaction.SenderId
            && ele.UnitClass==transaction.UnitClass && ele.UnitType==transaction.UnitType
            && ele.VestingType==transaction.VestingType && ele.UnitPool==transaction.UnitPool
          })
          if (index>=0) {
            TempVesting[index].Unit=(TempVesting[index].Unit-transaction.Unit).toFixed(2);
            TempVesting[index].VestedUnit=(TempVesting[index].VestedUnit-transaction.VestedUnit).toFixed(2);
            TempVesting[index].Percentage=TempVesting[index].VestedUnit/TempVesting[index].Unit;
            TempVesting[index].Percentage = TempVesting[index].Percentage ? TempVesting[index].Percentage : 'N/A';
          }
        }
      });




      //self.VestingReportData = TempVesting;
      //Fetch records from only Vesting Table with Override
      let overrideVestQuery = {
        batchQuery: true,
        filter: function(o) {
          return (
            o.BusinessEvent == "Vesting" &&
            (o.WorkflowStatus == "Approved" ||
              o.WorkflowStatus == "Correction Pending" ||
              o.WorkflowStatus == "Correction Approved") &&
            o.SpecialArrangement == "Override" &&
            moment(o.VestedDate) < moment(inputDate)
          );
        }
      };
      let VestingOverrideResult = this.withFilter(
        VestingReportConfig.list,
        overrideVestQuery
      );
      let orderedResult=_.reverse(_.sortBy(VestingOverrideResult, [function(o) { return o.Modified; }]))
      
 
      //Replcae Temp Vesting Array with Override Data.
      TempVesting.forEach(vestingRow => {
        let index=orderedResult.filter(function(ele) {
            return ele.ProgramId==vestingRow.ProgramId && ele.ReceiverId==vestingRow.ReceiverId
            && ele.UnitClass==vestingRow.UnitClass && ele.UnitType==vestingRow.UnitType
            && ele.VestingType==vestingRow.VestingType && ele.UnitPool==vestingRow.UnitPool
          })
         
          if (!isNullOrUndefined(index) && index.length > 0) {
            vestingRow.VestedUnit=0;
            vestingRow.Percentage=0;
             for (let j = 0; j < index.length; j++) {
            vestingRow.VestedUnit=vestingRow.VestedUnit+ index[j].VestedUnit;
            vestingRow.Percentage=vestingRow.Percentage+index[j].Percentage;
            vestingRow.Percentage = vestingRow.Percentage ? vestingRow.Percentage : "N/A";
            vestingRow.SpecialArrangement=index[j].SpecialArrangement;
             }
            vestingRow.VestedDate=index.map(function(e) { return e.VestedDate}).sort().reverse()[0] 
            vestingRow.Unit=vestingRow.VestedUnit/vestingRow.Percentage;
          }
      });


      //Assign to Kendo Grid
      self.VestingReportData = TempVesting;
    },
    calcSum(sourceArray, sourecField) {
      let sum=0
      sourceArray.forEach(function(obj) {
        sum=sum+obj[sourecField];
      });
      return sum;
    },
  }
};
</script>

<style>
#Standard {
  margin-left: 30px !important;
  /* background-color: #E5E5E5 !important; */
}

.chk-box {
  background-color: #f0f0f0 !important;
  border-radius: 0 !important;
}

.chk-box.k-state-active {
  background-color: #c7cdd5 !important;
}
.checkBox {
  text-align: center;
}

.checkBox input {
  margin: 0px 0px 0px 0px;
}

.checkBox label {
  margin: 0px 20px 0px 3px;
}
</style>
